// extracted by mini-css-extract-plugin
export var completionBody = "_c6-2";
export var completionCard = "_c6-0";
export var completionFooter = "_c6-3";
export var completionTitle = "_c6-1";